import * as t from "io-ts";

export const RouteStepCodec = t.intersection([
  t.type({
    distanceMeters: t.number,
    timeMillis: t.number,
  }),
  t.partial({
    text: t.number,
  }),
]);

export type RouteStep = t.TypeOf<typeof RouteStepCodec>;
